<router-outlet></router-outlet>
<main class="bg-gray-50 p-2 md:px-0 md:py-20 min-h-svh">
  <div class="max-w-6xl mx-auto  flex flex-col gap-4 ">
    @if (uiState() === 'COMPLETED') {
      <div>
        <h1>{{ 'block.order-confirmed.heading' | translate }}</h1>
        <p>{{ 'block.order-confirmed.description' | translate }}</p>

        <webmodule-order-alert [title]="'block.cart.support.title' | translate">{{ 'block.cart.support.description' | translate }}</webmodule-order-alert>
        <div class="grid grid-cols-2 gap-4">
          <webmodule-order-panel-customer />

          <webmodule-order-panel-cart [isCartOverview]="true" />
        </div>
      </div>
    } @else {
      <webmodule-order-zipcode-check />
      <div class="grid grid-cols-3 gap-4">
        <div class="col-span-2 flex flex-col gap-4">
<!--          <webmodule-order-panel-base></webmodule-order-panel-base>-->
          <webmodule-order-panel-internet [internetTypeSelection]="false"
                                          [index]="1"
                                          defaultInternetType="internet-only" />
          <webmodule-order-panel-mobile [index]="2" />
        </div>
        <div class="relative">
          <webmodule-order-panel-cart />
        </div>
      </div>
    }
  </div>
</main>
<taui-bottom-sheet-modal></taui-bottom-sheet-modal>

